import { request } from "../../../config/helpers/axios-instance";

const GetAllCarts = (params) => {
    return request({
        url: `cart/admin`,
        method: "GET",
        params,
    });
};

export default GetAllCarts;
